import { FinalTableConfig } from "../models/FinalTableConfig.interface";

export interface TableFunctionsConfig {
    indexFunction: any,
    actionsFunctions: Array<{name: string, function: any}>,
    bulkFunctions?: Array<{name: string, function: any}>,
    rowFunctions: Array<{name: string, function: any}>,
}
export const getTableConfig = (tableConfig: FinalTableConfig, tableFunctionsConfig: TableFunctionsConfig) => {
    tableConfig.index = tableFunctionsConfig;
    // Recorremos tableFunctionConfig.actions y añadimos las funciones a tableConfig.actions
    tableConfig.actions = tableConfig.actions.map((action) => {
        const actionFunction = tableFunctionsConfig.actionsFunctions.find((actionFunction) => actionFunction.name === action.name);
        if (actionFunction) {
            action.action = actionFunction.function;
        }
        return action;
    });
    // Recorremos tableFunctionConfig.rowActions y añadimos las funciones a tableConfig.rowActions
    tableConfig.rowActions = tableConfig.rowActions.map((rowAction) => {
        const rowActionFunction = tableFunctionsConfig.rowFunctions.find((rowActionFunction) => rowActionFunction.name === rowAction.name);
        if (rowActionFunction) {
            rowAction.action = rowActionFunction.function;
        }
        return rowAction;
    });
    // Recorremos tableFunctionConfig.bulkActions y añadimos las funciones a tableConfig.bulkActions
    if (tableFunctionsConfig.bulkFunctions && tableConfig.bulkActions) {
        tableConfig.bulkActions = tableConfig.bulkActions.map((bulkAction) => {            
            const bulkFunctions = tableFunctionsConfig.bulkFunctions ? tableFunctionsConfig.bulkFunctions : [];
            const bulkActionFunction = bulkFunctions.find((bulkActionFunction) => bulkActionFunction.name === bulkAction.name);
            if (bulkActionFunction) {
                bulkAction.action = bulkActionFunction.function;
            }
            return bulkAction;
        });
    }

    return tableConfig;    
}